import { render, staticRenderFns } from "./ViserChartDemo.vue?vue&type=template&id=6f53b42c&scoped=true&"
import script from "./ViserChartDemo.vue?vue&type=script&lang=js&"
export * from "./ViserChartDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f53b42c",
  null
  
)

export default component.exports